import React from 'react';
import {Heading, Box, HStack} from 'native-base';
import {IHistoryDetail} from '../../../../../interfaces/dtos';
import {
  ApprovedIcon,
  RejectedIcon,
  WaitingIcon,
} from '../../../../../components/icons';
import {HistoryStatus} from '../../../../../constants/enumerations';

interface IHeaderProps {
  detail: IHistoryDetail;
}

const HeaderSection = (props: IHeaderProps) => {
  const {detail} = props;
  const {status} = detail;

  return (
    <HStack
      width={'100%'}
      paddingX={42}
      alignItems="center"
      justifyContent={'space-between'}
      marginTop={5}
      marginBottom={5}>
      <Box>
        <Heading textTransform={'capitalize'} color="#06355E" fontSize={'20'}>
          {status.title.toLowerCase()}
        </Heading>
        {status.id >= HistoryStatus.rejected && (
          <Heading color="#06355E" fontSize={'16'}>
            {status.title.toLowerCase()}
          </Heading>
        )}
      </Box>

      <Box>
        {status.id === HistoryStatus.waiting && <WaitingIcon size={50} />}
        {status.id === HistoryStatus.approved && <ApprovedIcon size={50} />}
        {status.id >= HistoryStatus.rejected && <RejectedIcon size={50} />}
      </Box>
    </HStack>
  );
};
export default HeaderSection;
